import { IPaginationResponse } from '../../../data-access';
import { ICountriesResponse } from '../dtos';

const countriesResponse: IPaginationResponse<ICountriesResponse> = {
  items: [
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:49.6762263',
      modifiedOnUtc: '2025-02-18T20:11:49.6762398',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'Provider Center',
      arabicName: 'test',
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      referenceId: 5,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:49.5708603',
      modifiedOnUtc: '2025-02-18T20:11:49.5708733',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZZ TRAILERS',
      arabicName: 'test',
      id: 'ceb61384-9399-424e-8c42-2edcd3313483',
      referenceId: 58,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:49.4609054',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZZ TRAILER',
      arabicName: 'test',
      id: '8aa3f251-ec76-4409-8e0a-54c6c567dda2',
      referenceId: 55,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:49.349779',
      modifiedOnUtc: '2025-02-18T20:11:49.3497902',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZYBERGRAPH, LLC',
      arabicName: 'test',
      id: 'c02e2a8c-33a2-40ef-96d9-1a7da4b8bf29',
      referenceId: 15,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:49.2275572',
      modifiedOnUtc: '2025-02-18T20:11:49.2275702',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZUBIRIA',
      arabicName: 'test',
      id: '5634f64d-99d1-4190-bc0e-200f42d91344',
      referenceId: 9,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:49.1173562',
      modifiedOnUtc: '2025-02-18T20:11:49.117367',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZTPOWERSTATION',
      arabicName: 'test',
      id: '306005ef-d065-47b7-a667-7310f67d4ed3',
      referenceId: 6,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:49.0118576',
      modifiedOnUtc: '2025-02-18T20:11:49.0118805',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZTM',
      arabicName: 'test',
      id: 'ca733b2c-5320-48aa-9d39-d637176fd068',
      referenceId: 2,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:48.9133677',
      modifiedOnUtc: '2025-02-18T20:11:48.9133814',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZTECH INDUSTRIES',
      arabicName: 'test',
      id: 'ef2bfce0-2745-41d4-8961-cb68c3a75c50',
      referenceId: 1,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:48.8100311',
      modifiedOnUtc: '2025-02-18T20:11:48.8100427',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZROX EV, INC.',
      arabicName: 'test',
      id: '2dcde0f8-a77e-403a-bcb3-a4fc6b266114',
      referenceId: 7,
      code: "EG",
      phoneCode: "+20",
      currency: "Egyption Pound",
      currencyCode: "EGP",
      language: "Arabic",
      flag: "Egypt Flag"
    },
    {
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-18T20:11:48.6750079',
      modifiedOnUtc: '2025-02-18T20:11:48.6750234',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      englishName: 'ZOOX',
      arabicName: 'test',
      id: '14bbc0fa-1495-4c92-86e9-eb876100707c',
      referenceId: 4,
      code: "SA",
      phoneCode: "+966",
      currency: "Egyption Pound",
      currencyCode: "SAR",
      language: "Arabic",
      flag: "Saudi Flag"
    }
  ],
  paginationMetadata: {
    totalItemCount: 11706,
    numberOfPages: 1171,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: true,
    hasPrevious: false
  }
};
const countryResponse: ICountriesResponse = {
  isActive: true,
  status: 'Active',
  createdOnUtc: '2025-02-18T20:11:48.6750079',
  modifiedOnUtc: '2025-02-18T20:11:48.6750234',
  createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  englishName: 'ZOOX',
  arabicName: 'test',
  id: '14bbc0fa-1495-4c92-86e9-eb876100707c',
  referenceId: 4,
  code: "SA",
  phoneCode: "+966",
  currency: "Egyption Pound",
  currencyCode: "SAR",
  language: "Arabic",
  flag: "Saudi Flag"
};

export const countriesData = {
  countriesResponse,
  countryResponse
};
